// Occupancy colors, one rule for all views: below 35% green, 35% to 65% gold (amber), above 65% red.
export function occupancyTone(pct) {
  const v = Number(pct) || 0;
  if (v < 35) {
    return { key: "low", word: "niska", text: "text-success-dark dark:text-success-light", fill: "bg-success dark:bg-success-light" };
  }
  if (v <= 65) {
    return { key: "mid", word: "srednja", text: "text-warning-dark dark:text-warning-light", fill: "bg-warning dark:bg-warning-light" };
  }
  return { key: "high", word: "visoka", text: "text-danger-dark dark:text-danger-light", fill: "bg-danger dark:bg-danger-light" };
}
